import React, { useState } from 'react';
import './QA.css';
import Footer from '../Components/Footer';
import Header from '../Components/Header';

function QA() {
  const [openQuestionId, setOpenQuestionId] = useState(null);

  const toggleQuestion = (id) => {
    setOpenQuestionId(openQuestionId === id ? null : id);
  };

  const faqData = [
    {
      category: "Général",
      questions: [
        {
          id: "q1",
          question: "Quand puis-je récupérer et rendre le matériel ?",
          answer: "Le matériel peut être récupéré avant l'événement et doit être rendu dans un délai de 24 à 48 heures après l'événement."
        },
        {
          id: "q2",
          question: "Dans quel secteur géographique êtes-vous ?",
          answer: "Nous opérons principalement dans la la Vallée du Rhône. Une livraison est possible à partir de 50€ selon votre localisation."
        },
        {
          id: "q3",
          question: "Quels accessoires sont fournis avec le photobooth ?",
          answer: "• Boîtier du photobooth (avec appareil photo, tablette, etc.)\n• Imprimante DNP DS 620\n• Trépied Berlebach\n• Rallonge électrique (10 m)\n• Sacs de transport"
        },
        {
          id: "q4",
          question: "Le photobooth peut-il être installé à l'extérieur ?",
          answer: "Non, il doit être placé dans un endroit sécurisé et à l'abri des intempéries pour éviter tout risque de dommage."
        }
      ]
    },
    {
      category: "Paiement & Caution",
      questions: [
        {
          id: "q5",
          question: "Quand et comment dois-je payer la location ?",
          answer: "Le paiement doit être effectué au plus tard lors de la remise du matériel."
        },
        {
          id: "q6",
          question: "Pourquoi dois-je fournir une caution ?",
          answer: "Un chèque de 2500 € est demandé pour couvrir d'éventuels dommages au matériel. Il ne sera pas encaissé et sera restitué à la fin de la location si tout est rendu en bon état."
        },
        {
          id: "q7",
          question: "Que se passe-t-il si je perds ou endommage du matériel ?",
          answer: "Toute perte ou détérioration du matériel peut entraîner l'encaissement total ou partiel de la caution pour couvrir les frais de réparation ou de remplacement."
        }
      ]
    },
    {
      category: "Installation & Utilisation",
      questions: [
        {
          id: "q8",
          question: "Puis-je modifier les réglages du photobooth ?",
          answer: "Non, toute modification des réglages peut entraîner un dysfonctionnement. Si un problème survient, contactez le loueur."
        },
        {
          id: "q9",
          question: "Puis-je ouvrir le photobooth une fois installé ?",
          answer: "Non, sauf pour l'installation et la désinstallation. Le boîtier contient des composants sensibles et doit rester fermé pour assurer son fonctionnement."
        },
        {
          id: "q10",
          question: "Que faire en cas de problème technique ?",
          answer: "Vérifiez d'abord les branchements et suivez la procédure d'installation. Si le problème persiste, contactez le loueur"
        },
        {
          id: "q11",
          question: "Puis-je obtenir un remboursement en cas de panne ?",
          answer: "Si le photobooth présente un dysfonctionnement non réparable, une indemnisation partielle ou totale pourra être envisagée, dans la limite du tarif de location payé."
        },
        {
          id: "q12",
          question: "Ai-je besoin d'un technicien pour installer le photobooth ?",
          answer: "Non, l'installation est simple et peut être réalisée par deux personnes en suivant la procédure fournie."
        },
        {
          id: "q13",
          question: "Le photobooth fonctionne-t-il sur batterie ?",
          answer: "Non, une source électrique est nécessaire. Une rallonge de 10 mètres est incluse dans le kit."
        }
      ]
    },
    {
      category: "Impression & Photos",
      questions: [
        {
          id: "q14",
          question: "Puis-je imprimer plusieurs copies d'une photo ?",
          answer: "Oui, il est possible d'imprimer plusieurs exemplaires tant que le papier est disponible."
        },
        {
          id: "q15",
          question: "Que faire si l'imprimante ne fonctionne pas ?",
          answer: "Vérifiez les branchements (alimentation et connexion imprimante). Si le problème persiste, redémarrez le photobooth. Si cela ne fonctionne toujours pas, contactez le loueur."
        },
        {
          id: "q16",
          question: "Les photos sont-elles enregistrées quelque part ?",
          answer: "Oui, toutes les photos, qu'elles soient imprimées ou non, sont stockées et envoyées par mail aux organisateurs."
        }
      ]
    },
    {
      category: "Désinstallation & Transport",
      questions: [
        {
          id: "q17",
          question: "Comment dois-je restituer le matériel ?",
          answer: "Le photobooth et ses accessoires doivent être retournés en bon état, dans leurs sacs de transport respectifs."
        },
        {
          id: "q18",
          question: "Comment démonter le photobooth en toute sécurité ?",
          answer: "Il faut être deux et commencer par enlever l'imprimante du Photobooth avant de le démonter ! Ensuite, une personne maintient le photobooth pendant que l'autre dévisse la poignée de serrage sous le trépied."
        },
        {
          id: "q19",
          question: "Le matériel doit-il être transporté d'une manière spécifique ?",
          answer: "Oui, assurez-vous que les sacs sont bien placés dans le coffre et qu'ils ne bougent pas pendant le transport."
        }
      ]
    }
  ];

  return (
    <div className="div">

<Header />
    <div className="faq-container">
      <h1 className="faq-title">FAQ</h1>
      <p className="faq-subtitle">Tout ce que vous devez savoir sur notre service de photobooth</p>

      <div className="faq-content">
        {faqData.map((category, index) => (
          <div key={index} className="faq-category">
            <h2 className="category-title">{category.category}</h2>
            <div className="question-list">
              {category.questions.map((item) => (
                <div key={item.id} className="faq-item">
                  <div 
                    className={`faq-question ${openQuestionId === item.id ? 'active' : ''}`}
                    onClick={() => toggleQuestion(item.id)}
                  >
                    <span className="question-text">{item.question}</span>
                    <span className="toggle-icon">{openQuestionId === item.id ? '−' : '+'}</span>
                  </div>
                  {openQuestionId === item.id && (
                    <div className="faq-answer">
                      <p className="answer-text">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

   

    </div>
          <Footer />
          </div>
  );
}

export default QA;